import React, { useState, useContext, useEffect } from 'react';
import { CoreContext } from './context/index.js';
import { AccorAuthContext, loginWithAccor, signUpWithAccor } from './context/auth/index.js';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import Link from './components/Link/index.js';
import { D as Drawer } from './Drawer-J1RjFs7M.js';
import ForgotPasswordForm from './components/ForgotPasswordForm/index.js';
import LoginForm from './components/LoginForm/index.js';
import RegisterForm from './components/RegisterForm/index.js';
import { RegisterFormType } from './types/index.js';
import './utils/logToSlack.js';
import './animations--PMkOS0j.js';
import './index-QrdBfapu.js';
import 'cookies-next';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import { a as LOCAL_STORAGE_ADD_WISHLIST_PRODUCT } from './localStorage-NWX6x-k6.js';
import './payment-5CMab_Gs.js';
import './index-vPolXUOt.js';
import 'notistack';
import useShowNotify from './hooks/useShowNotify.js';
import 'lodash/get';
import './product-_pRduMz7.js';
import './helpers-qyZpLI0y.js';
import 'lodash';
import './utils/currency.js';
import './utils/price.js';
import 'next/server';
import './index-Oip0gjfj.js';
import './graphqlRequestClient-7kdUKc_c.js';
import { validateHCaptchaTokenOnServer } from './utils/captcha.js';
import { A as ActionType, M as MyAccount } from './MyAccount-HuAGC722.js';
import { w as withProviders } from './withProviders-l3mjYkR2.js';
import { c as classnames } from './index-2586sEvh.js';
import IconButton from './components/IconButton/index.js';

const AuthSidebar = ({ isOpen, isLogged, initialActionType = ActionType.Login, onLoginSubmitted, onClose, onLogout, }) => {
    var _a, _b;
    const { t: tHeading } = useTranslation('', { keyPrefix: '$common.$headings' });
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
    const { t: tCommon } = useTranslation('', { keyPrefix: '$common' });
    const { locale, asPath, reload } = useRouter();
    const showNotify = useShowNotify();
    const [actionType, setActionType] = useState(initialActionType);
    const [loginFormValues, setLoginFormValues] = useState(null);
    const { data: { siteConfig: { siteName, enableAccorLoyaltyProgramme = false }, }, } = useContext(CoreContext);
    const accorAuthContext = enableAccorLoyaltyProgramme ? useContext(AccorAuthContext) : null;
    const logoutWithAccor = (_a = accorAuthContext === null || accorAuthContext === void 0 ? void 0 : accorAuthContext.logoutWithAccor) !== null && _a !== void 0 ? _a : (async () => { });
    const isAccorLoggedIn = (_b = accorAuthContext === null || accorAuthContext === void 0 ? void 0 : accorAuthContext.isAccorLoggedIn) !== null && _b !== void 0 ? _b : false;
    const showAccount = isAccorLoggedIn || isLogged;
    const onToggleCreateAccount = (loginValues) => {
        if (enableAccorLoyaltyProgramme) {
            // Redirect to the register page if loyalty programme is disabled
            window.location.href = `/${locale}/user/register`;
            return;
        }
        setLoginFormValues(loginValues);
        setActionType(ActionType.Register);
    };
    const handleClose = () => {
        // For a guest user clear addWishlistProduct localStorage value after manual closing a Login sidebar
        if (!isLogged) {
            localStorage.removeItem(LOCAL_STORAGE_ADD_WISHLIST_PRODUCT);
        }
        if (enableAccorLoyaltyProgramme) {
            setActionType(showAccount ? ActionType.Account : ActionType.Initial);
        }
        else {
            setActionType(showAccount ? ActionType.Account : ActionType.Login);
        }
        onClose();
    };
    const handleAccorLogin = () => {
        loginWithAccor();
    };
    const handleAccorSignUp = () => {
        signUpWithAccor();
    };
    const handleAccorLogout = async () => {
        await logoutWithAccor();
    };
    useEffect(() => {
        if (enableAccorLoyaltyProgramme) {
            setActionType(ActionType.Initial);
            if (showAccount) {
                setActionType(ActionType.Account);
            }
            else {
                setActionType(ActionType.Initial);
            }
        }
        else {
            setActionType(ActionType.Login);
        }
    }, [asPath, isLogged, isAccorLoggedIn]);
    return (React.createElement(Drawer, { open: isOpen, onClose: handleClose, name: "auth-sidebar" },
        (() => {
            if (showAccount && actionType === ActionType.Account) {
                return (React.createElement("div", { className: classnames(enableAccorLoyaltyProgramme ? 'loyalty' : '') },
                    React.createElement("h2", { className: classnames('title', enableAccorLoyaltyProgramme ? 'loyalty-title' : '') }, tLabel('myAccount')),
                    React.createElement(MyAccount, { setActionType: setActionType, isLogged: isLogged, onAccorLogout: handleAccorLogout, onLogout: onLogout })));
            }
            return null;
        })(),
        !isLogged &&
            (() => {
                if (enableAccorLoyaltyProgramme && actionType === ActionType.Initial) {
                    return (React.createElement("div", { className: "loyalty" },
                        React.createElement("h2", { className: "title loyalty-title" },
                            `${tButton('signIn')} / ${tButton('signUp')}`,
                            ' '),
                        React.createElement("div", { className: "loyalty-block" },
                            React.createElement("h3", { className: "loyalty-title" }, tHeading('loyaltyProgrammeAccount')),
                            React.createElement("p", { className: "loyalty-text" }, tCommon('loyaltyProgrammeTip')),
                            React.createElement("div", { className: "loyalty-actions" },
                                React.createElement("button", { type: "button", onClick: () => handleAccorLogin(), className: "btn btn-main loyalty-btn" }, tButton('logIn')),
                                React.createElement("button", { type: "button", onClick: () => handleAccorSignUp(), className: "btn btn-plain loyalty-btn" }, tButton('signUpForFree')))),
                        React.createElement("div", { className: "loyalty-or" },
                            React.createElement("span", null, tCommon('or'))),
                        React.createElement("div", { className: "loyalty-block" },
                            React.createElement("h3", { className: "loyalty-title" }, tHeading('sitenameAccount', { siteName })),
                            React.createElement("p", { className: "loyalty-text" }, tCommon('loginTip')),
                            React.createElement("div", { className: "loyalty-actions" },
                                React.createElement("button", { type: "button", className: "btn btn-main", onClick: () => setActionType(ActionType.Login) }, tButton('logIn')),
                                React.createElement(Link, { href: `/${locale}/user/register`, className: "btn btn-plain", onClick: onClose }, tButton('signUp')))),
                        React.createElement("p", { className: "loyalty-faq" },
                            React.createElement("span", null,
                                tLabel('faqFooter'),
                                ": "),
                            tCommon('doubleLogin'),
                            React.createElement(Link, { onClick: handleClose, href: "/help/dual-account-logins" }, tButton('learnMore')))));
                }
                if (actionType === ActionType.Login) {
                    return (React.createElement(React.Fragment, null,
                        enableAccorLoyaltyProgramme && (React.createElement(IconButton, { btnClassName: "btn-back", iconClassName: "icon-left-arrow", title: tLabel('closeModal'), onClick: () => setActionType(showAccount ? ActionType.Account : ActionType.Initial) })),
                        React.createElement("h2", { className: "title", dangerouslySetInnerHTML: { __html: tHeading('loginHeading') } }),
                        React.createElement(LoginForm, { legend: tHeading('loginHeading'), showCreateAccountButton: true, validateHCaptchaTokenOnServer: validateHCaptchaTokenOnServer, onSubmitted: onLoginSubmitted, onToggleCreateAccount: onToggleCreateAccount, onToggleForgotPassword: () => setActionType(ActionType.ForgotPassword), onShowNotify: showNotify, showHCaptcha: true })));
                }
                return null;
            })(),
        actionType === ActionType.Register && !isLogged && (React.createElement(React.Fragment, null,
            enableAccorLoyaltyProgramme && (React.createElement(IconButton, { btnClassName: "btn-back", iconClassName: "icon-left-arrow", title: tLabel('closeModal'), onClick: () => setActionType(ActionType.Initial) })),
            React.createElement("h2", { className: "title" }, tLabel('createAccount')),
            React.createElement(RegisterForm, { formType: RegisterFormType.Drawer, loginFormValues: loginFormValues, siteSubscribeCheckbox: true, validateHCaptchaTokenOnServer: validateHCaptchaTokenOnServer, onBack: () => setActionType(ActionType.Login), onSubmitted: () => {
                    onClose();
                    reload();
                }, onShowNotify: showNotify }))),
        actionType === ActionType.ForgotPassword && !isLogged && (React.createElement(React.Fragment, null,
            enableAccorLoyaltyProgramme && (React.createElement(IconButton, { btnClassName: "btn-back", iconClassName: "icon-left-arrow", title: tLabel('closeModal'), onClick: () => setActionType(ActionType.Login) })),
            React.createElement("h2", { className: "title" }, tLabel('forgetPWDLink')),
            React.createElement(ForgotPasswordForm, { validateHCaptchaTokenOnServer: validateHCaptchaTokenOnServer, onSubmitCallback: handleClose, onShowNotify: showNotify, onBack: enableAccorLoyaltyProgramme ? null : () => setActionType(ActionType.Login) })))));
};
var AuthSidebar$1 = withProviders(AuthSidebar, { translation: true });

export { AuthSidebar$1 as A };
//# sourceMappingURL=AuthSidebar-8vLn4JQ6.js.map
